const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the global Analyze functions and properties
 * @argument {Videos} Videos the resource defined to manage Videos
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('mediaViewer', ['Application', 'Authorization', 'Analyze', 'Videos', 'ContentAuth', 'SurveyHelper', 'Content', '$window', '$translate', function (Application, Authorization, Analyze, Videos, ContentAuth, SurveyHelper, Content, $window, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentType: '=',
      contentId: '=',
      checkFull: '@',
      fullData: '=',
      onComplete: '&',
      trackId: '=?',
      allowComments: '&?',
      journeyId: '=?'
    },
    template: require('../../templates/directives/media-viewer.html'),
    controller: ['$scope', '$sce', function ($scope, $sce) {
      var self = this;
      self.currentUrl = Application.navigation.getUrl();
      self.allowedRoles = ['admin', 'creator'];
      self.routeParameters = Application.navigation.getRouteParameters();
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = self.allowedRoles.indexOf(Authorization.getAuthToken().user.role) !== -1;
      self.contentType = $scope.contentType;
      self.contentId = $scope.contentId;
      self.fileItems = [];
      self.inTrack = new RegExp('track').test(self.currentUrl) || !!$scope.trackId;
      self.inJourney = !!$scope.journeyId;
      self.inEditing = new RegExp('edit').test(self.currentUrl);
      self.markedComplete = false;
      self.translations = {};
      self.hideSurvey = true;
      self.expandSurvey = false;

      self.setVideo = function(data) {
        self.videoLink = data.link;
        self.videoSource = data.source || null;
        self.videoSourceId = data.source_id || null;
        self.videoCreated = data.createdAt || null;
        self.videoVtt = data.vtt_files || [];
      };

      self.recordSurveyView = () => {
        Analyze.record({resource: 'views'}, {content: self.item.surveys[0].survey_id, content_type: 'survey'});
      }
      
      self.tracking = new Application.Tracking(Analyze, moment, 'video', $scope.trackId || null);

      if (self.inTrack && !$scope.trackId) {
        var trackWatch = $scope.$watch('trackId', function(newVal) {
          if (newVal) {
            self.tracking.setTrackId($scope.trackId);
            trackWatch();
          }
        });
      }

      self.initializeVideo = function (callback) {
        var options = {
          subresource: self.contentId,
          fields: 'user,title,author,duration,category,type,link,link_name,description,images,explore_hide,source,source_id,tags,linked_category,youtube_id,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,createdAt,completion_percent,vtt_files,rating_configuration,average_rating,allow_comments,groups,surveys',
          'user-populate': 'first_name,last_name,email'
        };
        Videos.get(options , function (data) {
          ContentAuth.allowView(data).then(async function(allowed) {
            if (!allowed) {
              Application.messaging.addMessage({type: 'error', text: self.translations['mediaviewer.permission_error'], duration: 5});
              Application.navigation.back();
              return;
            }
            self.item = data;
            if (self.item.average_rating) {
              self.rating = Math.round(self.item.average_rating * 5) / 100;
            }
            $window.document.title = self.item.title;
            self.tracking.start(self.item);
            self.setVideo(data);
            if (!self.item.completion_percent) {
              self.completionActions();
            }
            if (data.allow_comments && $scope.allowComments) {
              $scope.allowComments();
            }
            if (self.item.surveys?.length) {
              const hideInContext = self.inJourney || self.inTrack;
              self.hideSurvey = await SurveyHelper.hideSurvey(hideInContext, self.item.surveys[0].survey_id, self.item._id);
              console.log(hideInContext);
              $scope.$apply();
            }
          });
        }, function (error) {
          console.log('Error occured getting video ', error);
        });
      };

      self.displayTime = function(time) {
        if (time && time < 60) {
          return self.translations['mediaviewer.less_than_a_minute'];
        }
        var mins = ~~(time / 60);
        var secs = time % 60;

        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = time % 60;

        var ret = "";

        if (hrs > 0) {
          ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
        }

        ret += "" + mins + (mins === 1 ? " min" : " mins");

        return ret;
      };

      self.idInit = function() {
        self.currentUrl = Application.navigation.getUrl();
        self.routeParameters = Application.navigation.getRouteParameters();
        self.user = Authorization.getAuthToken().user;
        self.isAdmin = self.allowedRoles.indexOf(Authorization.getAuthToken().user.role) !== -1;
        self.contentType = $scope.contentType;
        self.contentId = $scope.contentId;
        self.fileItems = [];
        self.markedComplete = false;

        self.initializeVideo();
        return;
      };

      self.fullDataInit = function() {
        if (!$scope.fullData.link) {
          return;
        }

        self.markedComplete = false;
        self.item = $scope.fullData;
        self.setVideo($scope.fullData);
        if (!$scope.fullData._id) {
          self.videoCreated = new Date();
        }
      };

      self.completionActions = function() {
        if (self.markedComplete) {
          return;
        }
        self.markedComplete = true;

        if ($scope.onComplete) {
          $scope.onComplete();
        } else if (self.inTrack) {
          var completeWatch = $scope.$watch('onComplete', function(newVal, oldVal){
            if (newVal && !oldVal) {
              $scope.onComplete();
              completeWatch();
            }
          });
        }

        Analyze.record({resource: 'views'}, {content: self.item._id, content_type: 'video'});
        Application.analyticsProvider.trackEvent('video_viewed', {content: self.item._id, content_type: 'video', title: self.item.title});

        const completionContexts = [];
        if (self.inTrack && $scope.trackId) {
          completionContexts.push({key: 'track', value: $scope.trackId});
        }
        if (self.inJourney) {
          completionContexts.push({key: 'journey', value: $scope.journeyId});
        }
        Content.complete({
          type: 'video', 
          id: self.item._id,
          contexts: completionContexts
        });
      };

      $scope.$on('$destroy', function() {
        self.tracking.end()
      });

      // Wait for delayed information
      if (!$scope.contentId) {
        if (!$scope.fullData || $scope.fullData && !$scope.fullData.link) {

          var watchFull = $scope.$watch('fullData.link', function(newVal, oldVal) {
            if (!newVal || oldVal === newVal) {
              return;
            }
            self.fullDataInit();
            watchFull();
          });

          return;
        }
      }

      $scope.$watch('contentId', function(newVal, oldVal) {
        if (!newVal || oldVal === newVal) {
          return;
        }
        self.idInit();
      });

      $translate([
        "mediaviewer.less_than_a_minute",
        "mediaviewer.permission_error"
      ]).then(function (translations) {
        self.translations = translations;
     });

      if (!$scope.checkFull) {
        self.idInit();
        return;
      }

      // full data scenario
      self.fullDataInit();

    }],
    controllerAs: 'viewer'
  };
}]);
